import initTextOverCarousel from "../initTextOverCarousel.js";

document.addEventListener("DOMContentLoaded", () => {
  initTextOverCarousel();
});
